function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  width: 7,
  height: 14,
  rx: 3.5,
  fill: "#F68BB6"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 53.2188,
  y: 3.27344,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(30 53.2188 3.27344)",
  fill: "#E783CA"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 59.6016,
  y: 28.7812,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(-120 59.6016 28.7812)",
  fill: "#E577C3"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 61,
  y: 41,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(-90 61 41)",
  fill: "#E268BF"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 56.1016,
  y: 52.2812,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(-60 56.1016 52.2812)",
  fill: "#EF61C9"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 46.2188,
  y: 59.6016,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(-30 46.2188 59.6016)",
  fill: "#DD4FC4"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 61,
  width: 7,
  height: 14,
  rx: 3.5,
  fill: "#FFD168"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 22.7188,
  y: 56.1016,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(30 22.7188 56.1016)",
  fill: "#FFC74C"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 6.77734,
  y: 59.2812,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(-120 6.77734 59.2812)",
  fill: "#FFB860"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  y: 41,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(-90 0 41)",
  fill: "#FFB357"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 3.27344,
  y: 21.7812,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(-60 3.27344 21.7812)",
  fill: "#FFA538"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 15.7188,
  y: 6.77441,
  width: 7,
  height: 14,
  rx: 3.5,
  transform: "rotate(-30 15.7188 6.77441)",
  fill: "#FE9A60"
});

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.89d702d6.svg";
export { ForwardRef as ReactComponent };